import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class CockpitEditService {
	private restartCockpitUrl = environment.baseApiUrl + 'cockpit';

	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	restartCockpit(): Observable<any> {
		return this.http.delete(this.restartCockpitUrl, { headers: this.headers });
	}
}
